<!-- Simple modal for notification only. No action to be taken -->
<template>
   <modal :hideClose="true">
      <div slot="header">
      </div>

      <div slot="subhead">
         This {{object}} is currently locked
      </div>

      <div slot="body">
         <div class="modal-input-explain">You can unlock it now but it would lock {{user}} out of the {{object}}.
         </div>
      </div>

      <div slot="footer">

         <div>
            <div>
               <button class="btn-yellow" @click="$emit('unlock')">Unlock</button>
               <button class="btn-yellow" @click="$emit('cancel')">Cancel</button>
            </div>
         </div>

      </div>
   </modal>
</template>

<script>
import Modal from '@/global/modals/Modal';

export default {

   data() {
      return {
         inputData: ''
      }
   },

   props: {
      user: {
         type: String,
         required: true,
      },
      object: {
         type: String,
         required: true
      }
   },

   components: {
      Modal
   }
}
</script>